import React from 'react'

import { WebsiteText } from '../../components/WebsiteText'

export const SectionTitle = ({ children }: { children: React.ReactNode }) => {
  return (
    <WebsiteText variant="smallUppercase" className="margin-bottom-24 shade-20">
      {children}
    </WebsiteText>
  )
}
